import { Link, useLocation } from "react-router-dom";
import "./uistyle.css"

function MenuNavLink(props) {
    const location = useLocation();
    const isActive = location.pathname === props.link; // проверяем текущий путь

    return (
        <Link
            className={`menu-link ${isActive ? "active-menu-link" : ""}`}
            to={props.link ?? "/topics"}
            state={props.state}
        >
            <div className="menu-link_icon">
                <i className={props.icon ?? "pi pi-home"}></i>
            </div>
            <div className="menu-link_link">{props.label}</div>
        </Link>
    );
}

export default MenuNavLink;
